import * as React from 'react';
import Rotation from '@bytebrand/fe-react-rotation';
import { Loader } from '@bytebrand/fe-ui-core-autobahn/compat';
import Slide from './Slide';
import { preloadImages } from '../../../../framework/utils/CommonUtils';
import styles from './SliderMain.styl';
const TIMEOUT = 250;
const imageProps = {
    withAnimation: false,
    withLoader: false
};
export const SliderExterior = React.forwardRef(({ photos, ratioW, ratioH, scale, isMultiTouch }, ref) => {
    const [frame, setFrame] = React.useState(0);
    const [pressed, setPressed] = React.useState(false);
    const [isLoadedPhotos, setLoadedPhotos] = React.useState(false);
    const [hasErrorLoadPhotos, setErrorLoadPhotos] = React.useState(false);
    const timerRef = React.useRef(null);
    const rotationRef = React.useRef(null);
    /* eslint-disable indent,@typescript-eslint/indent */
    const style = React.useMemo(() => ({
        cursor: pressed ? 'ew-resize' : 'grab',
        visibility: isLoadedPhotos ? 'unset' : 'hidden',
        height: '100%',
        overflow: 'hidden'
    }), [pressed, isLoadedPhotos]);
    const handleMouseDown = React.useCallback(() => setPressed(true), []);
    const handleMouseUp = React.useCallback(() => setPressed(false), []);
    const handleReload = React.useCallback(() => {
        setLoadedPhotos(false);
        setErrorLoadPhotos(false);
        preloadImages(photos.map(({ imageUrlLarge }) => imageUrlLarge), () => setLoadedPhotos(true), () => setErrorLoadPhotos(true));
    }, [photos]);
    React.useImperativeHandle(ref, () => {
        const left = () => setFrame(frame => frame > 0 ? frame - 1 : photos.length - 1);
        const right = () => setFrame(frame => frame < photos.length - 1 ? frame + 1 : 0);
        let isRotation = false;
        const start = (rotate) => {
            clearInterval(timerRef.current);
            timerRef.current = setInterval(() => {
                rotate();
                isRotation = true;
            }, TIMEOUT);
        };
        const stop = () => {
            clearInterval(timerRef.current);
            isRotation = false;
        };
        const end = (rotate) => {
            if (!isRotation) {
                rotate();
            }
            stop();
        };
        return {
            rotateLeftStart: () => start(left),
            rotateRightStart: () => start(right),
            rotateLeftEnd: () => end(left),
            rotateRightEnd: () => end(right),
            stopRotation: stop
        };
    }, []);
    React.useEffect(() => () => clearInterval(timerRef.current), []);
    React.useEffect(() => {
        rotationRef.current.setCurrentFrame(frame);
    }, [frame]);
    React.useEffect(() => {
        preloadImages(photos.map(({ imageUrlLarge }) => imageUrlLarge), () => setLoadedPhotos(true), () => setErrorLoadPhotos(true));
    }, [photos]);
    /* eslint-enable indent,@typescript-eslint/indent */
    return (React.createElement("div", { className: styles.wrapper },
        !isLoadedPhotos && hasErrorLoadPhotos ? (React.createElement("div", { className: styles.reload, onClick: handleReload }, "Error...")) : false,
        !isLoadedPhotos && !hasErrorLoadPhotos ? (React.createElement(Loader, { className: styles.loader })) : false,
        React.createElement("div", { style: style, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp },
            React.createElement(Rotation, { ref: rotationRef, scroll: false, cycle: true, onChange: setFrame, className: styles.wrapper, swipe: scale === 1 && !isMultiTouch }, photos.map(({ imageUrlLarge }, index) => (React.createElement("div", { key: index, className: styles.wrapper },
                React.createElement(Slide, { key: index, imageUrl: imageUrlLarge, ratioW: ratioW, ratioH: ratioH, scale: index === frame ? scale : 1, imageProps: imageProps }))))))));
});
